import React from 'react';
import { object } from 'prop-types';

import classes from './PanelInsert.module.css';

const ClientPanelInsert = ({node}) => {
    return (
        <dl className={classes.agentInfo}>
            <dt>Name</dt>
            <dd>{node.name}</dd>

            <dt>Address</dt>
            <dd>{node.address?.formattedAddress}</dd>

            <dt>Business Type</dt>
            <dd>{node.businessType?.name}</dd>

            <dt>Primary Contact</dt>
            <dd>{node.primaryContact?.name}</dd>
        </dl>
    );
};

ClientPanelInsert.defaultProps = {
    node: {}
};

ClientPanelInsert.propTypes = {
    node: object.isRequired
};

export default ClientPanelInsert;
